
import { useTranslation } from "react-i18next";
import {  TextInputControllerType1 } from "../controller/TextInputControllerType1";
import CSSClassSerivce from "../../../../services/CommonCSSSerivce";

interface TextInputProps {
    readOnly?: boolean;
    testId?: string;
    placeholder?:string;
    name: string | undefined;
    classNameInput: string;
    disabledAddClass:string;
    defaultValue: string | undefined;
    onInputChange?: ((it: string)=> void) | null
    disabled?: boolean | undefined
}

const TextInputReadOnlyType1: React.FC<TextInputProps> = (props) => {
    
  //console.log("TextInputReadOnlyType1 START")
  const { t } = useTranslation();

  let c = TextInputControllerType1({defaultValue: props.defaultValue, disabled: props.disabled, classNameFrame:"", classNameInput:  props.classNameInput, disabledClass: props.disabledAddClass})

  //let key = props.defaultValue?props.defaultValue:CommonService.getRandomHash()
  let key = props.defaultValue


  return (
    <div>
      <label htmlFor={props.name} className={CSSClassSerivce.labelClass}>{t(props.name?props.name:"")}</label>
      <div ref={(it) =>c.setRefDiv(it)} >
        <input 
          key={key} //hint: keychange triggers input to reRender
          data-testid = {props.testId}
          ref={c.refInput}
          className={props.classNameInput}
          type="text"
          placeholder={props.placeholder}
          id={props.name}
          name={props.name}
          //defaultValue={props.defaultValue} //???
          value={props.defaultValue}
          //defaultValue={props.defaultValue}
          //value={props.defaultValue}
          onChange={(e)=>{ try { 
            //console.log("readOnly e.target.defaultValue: "+e.target.defaultValue)
            props.onInputChange ? props.onInputChange(e.target.defaultValue) : {} 
          } catch(e) { } }}
        />
      </div>
    </div>
  );
};

export default TextInputReadOnlyType1;